import {
  ContentSection,
  PageSection,
} from "@tiicker/util/lib/contentful/types";
import { Entry } from "contentful";
import React from "react";
import styles from "./PartnerWithUsShareholderSubSection.module.scss";
import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import Markdown from "components/Markdown/Markdown";

interface Props {
  shareHolderSubSection: Entry<PageSection>;
  contentSections: Entry<ContentSection>[] | null;
}

const PartnerWithUsShareholderSubSection = (props: Props) => {
  const image = getImageReference(props.shareHolderSubSection.fields.image);
  return (
    <>
      <div className={styles.PartnerWithUsShareholderSubSection}>
        <div
          className={styles.PartnerWithUsShareholderSubSection__textContainer}
        >
          <h4 className={styles.PartnerWithUsShareholderSubSection__title}>
            {props.shareHolderSubSection.fields.displayTitle}
          </h4>
          {props.shareHolderSubSection.fields.description && (
            <Markdown
              className={
                styles.PartnerWithUsShareholderSubSection__markdownContainer
              }
              markdownText={props.shareHolderSubSection.fields.description}
            />
          )}
          {props.contentSections && (
            <div
              className={
                styles.PartnerWithUsShareholderSubSection__bottomContainer
              }
            >
              {props.contentSections.map((section: Entry<ContentSection>) => {
                const image = getImageReference(section.fields.image);
                return (
                  <div
                    className={
                      styles.PartnerWithUsShareholderSubSection__sectionContainer
                    }
                  >
                    <img
                      className={
                        styles.PartnerWithUsShareholderSubSection__icon
                      }
                      src={image?.fields.file.url}
                      alt={image?.fields.description}
                    />
                    <div
                      className={
                        styles.PartnerWithUsShareholderSubSection__contentContainer
                      }
                    >
                      <p
                        className={
                          styles.PartnerWithUsShareholderSubSection__multiBody
                        }
                      >
                        {section.fields.textContent}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className={styles.PartnerWithUsShareholderSubSection__image}>
          <img src={image?.fields.file.url} alt={image?.fields.description} />
        </div>
      </div>
    </>
  );
};

export default PartnerWithUsShareholderSubSection;
